import type { PromptOptions } from "#types/PromptOptions.ts";

import { create } from "zustand";

interface PromptOptionsStore {
    promptOptions?: PromptOptions;
    setPromptOptions: (options?: PromptOptions) => void;
}

export const usePromptOptionsStore = create<PromptOptionsStore>()(set => ({
    promptOptions: undefined,
    setPromptOptions: promptOptions => set({ promptOptions })
}));
